import {Component, OnInit, Injector, AfterViewInit} from '@angular/core';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {wizardSaved, chartingSaved, entrysignalsSaved, tiWizardSaved, ISavedScansOnePool} from '../interfaces/scanner.interfaces';
import {ScannerPrimarySearchList, ScannerChartingStudy} from '../interfaces/scanner.enums';
import {Workspace} from '../../../model/workspace.data';
import {ShowScanDeleteModal} from '../../modals/scanDelete/scanDelete.component';
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";

@Component({
    selector: 'app-savedScans',
    template: require('./savedScans.component.html'),
    styles: [require('./savedScans.component.scss')]
})
export class SavedScansComponent extends AppComponentBase implements OnInit, AfterViewInit {
    ngAfterViewInit(): void {
        $(".saves").mCustomScrollbar({
            axis: "y",
            theme: "inset-3", // "minimal-dark",
            scrollbarPosition: "outside",
            alwaysShowScrollbar: 0, // 0,1,2
            scrollButtons: {
                enable: true
            },
            mouseWheel: {
                enable: true
            }
        });
    }

    constructor(injector: Injector) {

        super(injector);

        // this.workspace.globaGridMode.fullScreenScanerAction.subscribe(v=>{
        //   if(v=="backFromNarrow")
        //   {
        //       if(this.lastLoadedPrimary!="")
        //       {
        //           this.loadAndSetActive(this.lastLoadedPrimary)
        //       //   this.workspace.selectedSavedScan = this.lastLoadedPrimary;
        //       }
        //   }
        // })

        this.workspace.globaGridMode.fullScreenScanerAction.subscribe(v => {

            if(v=="newScan")
            this.key = "";
            
        })

    }

    ngOnInit() {

    }

    public get savedScansOnePool() {
        return this.workspace.savedScansOnePool;
    }

    public actionDeleteOnePool(key: string, tab?: string) {
        ShowScanDeleteModal(this.modalService, key, tab)
    }

    private _key: string = "";
    public get key(): string {
        return this._key;
    }
    public set key(value: string) {
        this._key = value;
    }

    public loadAndSetActive(itemkey: string, event?: any) {
        try{
        if(this.key == itemkey) return;
        this.key = itemkey;
        setTimeout(() => {

           

            if(this.workspace.isNarrowScanMode) {
                this.workspace.globaGridMode.fullScreenScanerAction.next("backFromNarrow");

            }
            let selected = this.savedScansOnePool.find(v => v.key == itemkey);

            if(selected) {
                this.workspace.selectedSavedScan = selected.key
                this.loadAction(selected);
                this.workspace.globaGridMode.updateScanList.next("update");
            } else {
                this.workspace.selectedSavedScan = "";
            }
        }, 500);
    }
    catch(e)
    {
        console.log(e)
    }
    }

    private _lastLoadedPrimary: string = "";
    public get lastLoadedPrimary(): string {
        return this._lastLoadedPrimary;
    }
    public set lastLoadedPrimary(value: string) {
        this._lastLoadedPrimary = value;
    }

    public loadAction(item: ISavedScansOnePool | undefined) {
        this.workspace.initLoadScan = item;

        if(item) {
            // if(!this.workspace.isNarrowScanMode)
            // {


            let scannerType = item.savedData.primary;
            this.workspace.selectedPrimaryScanner = item.savedData.primary;
            this.workspace.scannerSearch_market = item.savedData.market;
            
            this.workspace.AppTick();
            if(item.savedData.primary != ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS) {

                this.workspace.scannerSearch_period = (<wizardSaved | tiWizardSaved | chartingSaved> item.savedData).period;

            }

            if(item.savedData.primary == ScannerPrimarySearchList.SCANNER_CHARTING) {
                this.workspace.scannerSearch_chartingstudy = (<chartingSaved> item.savedData).study;
            }


            if(item.savedDataSecondary) {


                this.workspace.narrowScanComponent = item.savedDataSecondary.primary;


                this.workspace.scannerSearch_market = item.savedData.market;

                if(item.savedDataSecondary.primary != ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS) {

                    this.workspace.scannerSearch_Narrow_period = (<wizardSaved | tiWizardSaved | chartingSaved> item.savedDataSecondary).period;

                }

                if(item.savedDataSecondary.primary == ScannerPrimarySearchList.SCANNER_CHARTING) {
                    this.workspace.scannerSearch_Narrow_chartingstudy = (<chartingSaved> item.savedDataSecondary).study;
                }

            }


            this.workspace.globaGridMode.loadScannerRule.next(item);
            this.workspace.canSelectedSavedScanUpdate = false;

        }

        // }
    }


    public saveScanParams(itemkey: string, event: any) {

        let selected = this.savedScansOnePool.find(v => v.key == itemkey);

        if(selected) {
            if(selected.savedData.name != event.target.innerHTML && event.target.innerHTML != "") {
                selected.savedData.name = event.target.innerHTML;

                this.workspace.addSavedScan();
            }
        }



    }


}
